var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewSharePreserveSeperator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.125,
    height: 19.103,
    viewBox: "0 0 19.125 19.103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00dde9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#0098f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Projector_Logo_horiz_reverse",
    "data-name": "Projector Logo horiz reverse",
    transform: "translate(-255.59 -379.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895",
    transform: "translate(255.59 379.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M172.281,381.562a5.781,5.781,0,1,0-5.781-5.781A5.792,5.792,0,0,0,172.281,381.562Zm3.108-7.237a1.478,1.478,0,1,1-1.478,1.478A1.479,1.479,0,0,1,175.389,374.325Zm-3.108-3.13a1.478,1.478,0,1,1-1.478,1.478A1.479,1.479,0,0,1,172.281,371.2Zm.717,4.586a.739.739,0,1,1-.739-.739A.761.761,0,0,1,173,375.781Zm-.717,1.652a1.478,1.478,0,1,1-1.478,1.478A1.479,1.479,0,0,1,172.281,377.433Zm-4.607-1.652a1.478,1.478,0,1,1,1.478,1.478A1.479,1.479,0,0,1,167.674,375.781Z",
    transform: "translate(-162.718 -366.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M158.663,352.1a9.563,9.563,0,0,0-9.563,9.563,9.432,9.432,0,0,0,2.021,5.846V361.38h.022a7.519,7.519,0,1,1,1.739,5.259v2.608a9.552,9.552,0,1,0,5.781-17.147Z",
    transform: "translate(-149.1 -352.1)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSharePreserveSeperator);
export default __webpack_public_path__ + "static/media/view-share-preserve-seperator.701e3d142051f05dd0a2087944f46ef3.svg";
export { ForwardRef as ReactComponent };